import React, { useEffect } from "react";
import {
  Wind,
  Heart,
  Flag,
  Sun,
  Sparkles,
  Flame,
  ArrowRight,
  Hexagon,
  Clock,
  ScanFace,
  Gem,
  HandHeart,
  Activity,
  Anchor,
  Mountain,
  Waves,
  Leaf,
  Compass,
  PersonStanding,
} from "lucide-react";

const TG_LINK = "https://t.me/elenefremova";
const TG_LINK_PREFILLED =
  "https://t.me/elenefremova?text=" +
  encodeURIComponent(
    "Елена, здравствуйте! Я была на вашем сайте и хочу записаться на дыхательную сессию. Буду рада узнать, что дальше :)"
  );

/* ---------- Decorative SVGs ---------- */
const BreathLines = ({ className = "", style = {} }) => (
  <svg
    viewBox="0 0 600 400"
    className={`breath-lines ${className}`}
    style={style}
    fill="none"
    stroke="#c97559"
    strokeWidth="0.6"
    aria-hidden="true"
  >
    <path d="M-20,80 C150,40 350,180 620,60" opacity="0.35" />
    <path d="M-20,150 C150,110 350,250 620,130" opacity="0.25" />
    <path d="M-20,230 C150,190 350,320 620,210" opacity="0.18" />
    <path d="M-20,310 C150,270 350,390 620,290" opacity="0.12" />
  </svg>
);

const LeafSprig = ({ className = "", flip = false, color = "#a9b8a0" }) => (
  <svg
    viewBox="0 0 200 260"
    className={className}
    style={{ transform: flip ? "scaleX(-1)" : "none" }}
    fill="none"
    stroke={color}
    strokeWidth="1.2"
    aria-hidden="true"
  >
    <path d="M100,250 C100,200 100,120 100,10" />
    <path
      d="M100,210 C70,200 55,180 45,155 C70,158 90,175 100,200 Z"
      fill={color}
      opacity="0.45"
      stroke="none"
    />
    <path
      d="M100,175 C130,165 145,143 155,115 C130,119 110,137 100,163 Z"
      fill={color}
      opacity="0.45"
      stroke="none"
    />
    <path
      d="M100,135 C70,125 58,102 50,78 C75,82 92,100 100,125 Z"
      fill={color}
      opacity="0.45"
      stroke="none"
    />
    <path
      d="M100,100 C130,90 142,67 150,43 C125,47 110,65 100,90 Z"
      fill={color}
      opacity="0.45"
      stroke="none"
    />
    <path
      d="M100,60 C75,55 65,38 60,18 C82,22 95,38 100,55 Z"
      fill={color}
      opacity="0.45"
      stroke="none"
    />
  </svg>
);

const GrassSprig = ({ className = "", flip = false }) => (
  <svg
    viewBox="0 0 120 200"
    className={className}
    style={{ transform: flip ? "scaleX(-1)" : "none" }}
    fill="none"
    stroke="#cbb9a6"
    strokeWidth="1"
    aria-hidden="true"
  >
    <path d="M60,200 C50,160 35,90 20,20" opacity="0.6" />
    <path d="M60,200 C60,140 55,80 50,15" opacity="0.7" />
    <path d="M60,200 C70,150 80,90 95,25" opacity="0.6" />
    <path d="M60,200 C80,160 95,100 110,40" opacity="0.5" />
    <path d="M60,200 C40,150 30,90 15,40" opacity="0.5" />
  </svg>
);

/* Custom small icons matching mockup style - hand-drawn beige/tan */
const IconBreath = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#b89b7a" strokeWidth="1.1" strokeLinecap="round">
    <path d="M4 12 C 8 10, 12 10, 14 12 C 16 14, 18 14, 22 12" />
    <path d="M4 18 C 8 16, 14 16, 18 18 C 22 20, 24 20, 28 18" />
    <path d="M4 24 C 8 22, 12 22, 16 24" />
  </svg>
);
const IconBody = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#b89b7a" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="16" cy="6" r="2.2" />
    <path d="M16 9 L16 19 M9 13 L23 13 M11 19 L16 27 M21 19 L16 27" />
  </svg>
);
const IconFeelings = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#b89b7a" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 5 C 11 9, 11 17, 16 22 C 21 17, 21 9, 16 5 Z" />
    <line x1="16" y1="5" x2="16" y2="28" />
  </svg>
);
const IconEnergy = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#b89b7a" strokeWidth="1.1" strokeLinecap="round">
    <circle cx="16" cy="16" r="4.5" />
    <path d="M16 3 L16 7 M16 25 L16 29 M3 16 L7 16 M25 16 L29 16 M6.5 6.5 L9 9 M23 23 L25.5 25.5 M25.5 6.5 L23 9 M9 23 L6.5 25.5" />
  </svg>
);
const IconEmotions = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#b89b7a" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 7 C 11 11, 12 19, 16 22 C 20 19, 21 11, 16 7 Z" fill="none" />
    <path d="M16 13 C 14 14, 14 17, 16 18 C 18 17, 18 14, 16 13 Z" fill="#b89b7a" opacity="0.3" />
  </svg>
);
const IconHeart = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" stroke="#b89b7a" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 26 C 7 19, 4 14, 7 10 C 10 6, 14 8, 16 11 C 18 8, 22 6, 25 10 C 28 14, 25 19, 16 26 Z" />
  </svg>
);

/* ---------- Header ---------- */
const Header = ({ overlay = false }) => {
  const nav = [
    { label: "Обо мне", href: "#about-master" },
    { label: "Кому подойдёт", href: "#resonance-section" },
    { label: "О методе", href: "#method" },
    { label: "Форматы", href: "#formats" },
    { label: "Контакты", href: TG_LINK },
  ];

  const [open, setOpen] = React.useState(false);

  return (
    <header
      className={`w-full px-6 lg:px-12 py-6 relative z-30 ${
        overlay ? "absolute top-0 left-0 right-0" : ""
      }`}
    >
      <div className="max-w-[1500px] mx-auto flex items-center justify-between lg:justify-center relative">
        <a
          href="#top"
          className="uppercase tracking-[0.32em] text-warm text-[11px] lg:text-[12px]"
          data-testid="logo-text"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300, fontStyle: "normal" }}
        >
          Breathwork Ceremony
        </a>

        <button
          aria-label="Меню"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2"
          data-testid="mobile-menu-button"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3d342e" strokeWidth="1.2" strokeLinecap="round">
            <line x1="4" y1="8" x2="20" y2="8" />
            <line x1="4" y1="16" x2="20" y2="16" />
          </svg>
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          className="lg:hidden absolute top-full left-0 right-0 bg-[#fbf4ed] shadow-lg p-6 flex flex-col gap-4 z-50"
          data-testid="mobile-menu"
        >
          {nav.map((item, i) => (
            <a
              key={i}
              href={item.href}
              target={item.href.startsWith("http") ? "_blank" : undefined}
              rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
              onClick={() => setOpen(false)}
              className="text-[12px] tracking-[0.26em] uppercase text-warm font-light hover:text-terracotta transition-colors"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
};

/* ---------- Hero ---------- */
const HERO_PARAGRAPHS = [
  "Индивидуальная работа с женщинами через дыхание, тело и живой диалог.",
  "Мы исследуем то, что происходит в твоей жизни сейчас, обращаемся к телу и используем дыхание как способ пройти глубже привычных мыслей и прикоснуться к тому, что ты действительно чувствуешь.",
  "Эта работа помогает восстановить контакт с собой, своими чувствами, желаниями и телом. Снять накопленное напряжение, дать место тому, что долго оставалось непрожитым, и постепенно вернуть внутреннюю опору. Научится замечать свои настоящие потребности, слышать свои «да» и «нет», доверять собственным ощущениям и всё меньше принимать решения из страха, привычки или ожиданий других. Не искать ответы снаружи, а всё яснее слышать свои.",
  "Всё, что происходит на наших встречах, становится частью твоего опыта и постепенно переходит в жизнь, меняя то, как ты чувствуешь себя, взаимодействуешь с собой и миром, делаешь выборы и встречаешь то, что приходит в твою жизнь.",
];

const Hero = () => {
  const HERO_BG =
    "https://customer-assets-eiarnc6j.emergentagent.net/job_webpage-prototype/artifacts/xrfv4g7x_2026-08-25%2023.41.04.jpg";
  const HERO_MOBILE =
    "https://customer-assets-eiarnc6j.emergentagent.net/job_webpage-prototype/artifacts/xrfv4g7x_2026-08-25%2023.41.04.jpg";

  const ContentInner = ({ compact = false }) => (
    <>
      <h1
        className="text-warm font-normal tracking-[0.01em] leading-[1.05]"
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontWeight: 400,
          fontSize: compact ? "clamp(26px, 7.65vw, 34px)" : "clamp(30px, 3.6vw, 51px)",
        }}
        data-testid="hero-title"
      >
        <span
          className="inline-block leading-none"
          style={{ fontSize: compact ? "1.7em" : "1.15em" }}
        >
          ДЫХАНИЕ
        </span>
        {" —"}
        <br />
        <span className="text-terracotta whitespace-nowrap italic">
          ТВОЙ КЛЮЧ К&nbsp;СЕБЕ
        </span>
      </h1>

      <div
        className={`${compact ? "mt-7" : "mt-10"} max-w-md space-y-4`}
        data-testid="hero-subtitle-wrap"
      >
        {HERO_PARAGRAPHS.map((text, i) => (
          <p
            key={i}
            className="text-warm-light"
            data-testid={`hero-paragraph-${i}`}
            style={{ fontFamily: "Manrope, sans-serif", fontSize: "15px", lineHeight: 1.6, fontWeight: 400 }}
          >
            {text}
          </p>
        ))}
      </div>

      <div className={`${compact ? "mt-10 flex-col w-full" : "mt-12"} flex flex-wrap gap-4`}>
        <a
          href={TG_LINK_PREFILLED}
          target="_blank"
          rel="noopener noreferrer"
          className={`btn-primary ${compact ? "text-center w-full" : ""}`}
          data-testid="hero-start-button"
        >
          Начать практику
        </a>
        <a
          href="#resonance-section"
          onClick={(e) => {
            e.preventDefault();
            const el = document.getElementById("resonance-section");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          className={`btn-outline ${compact ? "text-center w-full" : ""}`}
          data-testid="hero-formats-button"
        >
          Узнать больше
        </a>
      </div>
    </>
  );

  return (
    <section
      id="top"
      className="relative w-full overflow-hidden"
      data-testid="hero-section"
    >
      {/* DESKTOP layout */}
      <div className="hidden lg:block relative min-h-[100vh] overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={HERO_BG}
            alt="Woman breathing in the sunlight"
            className="w-full h-full object-cover object-right"
            data-testid="hero-image"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(90deg, rgba(251,244,237,0.95) 0%, rgba(251,244,237,0.82) 30%, rgba(251,244,237,0.4) 55%, rgba(251,244,237,0) 80%)",
            }}
          />
        </div>

        <Header overlay />

        <div className="relative z-10 px-6 lg:px-14 pt-20 pb-16 min-h-[100vh] flex items-center max-w-[1500px] mx-auto">
          <div className="max-w-2xl fade-in-up -mt-12">
            <ContentInner />
          </div>
        </div>

        <BreathLines className="absolute -top-10 -left-20 w-[700px] h-[420px] z-[1] opacity-30" />
      </div>

      {/* MOBILE layout - photo on top, text below */}
      <div className="lg:hidden bg-cream relative">
        <div className="relative w-full aspect-[4/5] overflow-hidden">
          <img
            src={HERO_MOBILE}
            alt="Woman breathing in the sunlight"
            className="w-full h-full object-cover object-[60%_top]"
            data-testid="hero-image-mobile"
          />
          {/* Header overlays on top of image */}
          <div className="absolute top-0 left-0 right-0 z-20">
            <Header overlay />
          </div>
          {/* Soft fade at bottom to blend with content */}
          <div
            className="absolute inset-x-0 bottom-0 h-40 pointer-events-none"
            style={{
              background:
                "linear-gradient(180deg, rgba(251,244,237,0) 0%, rgba(251,244,237,1) 100%)",
            }}
          />
        </div>
        <div className="px-6 pb-8 -mt-60 relative z-10">
          <ContentInner compact />
        </div>
      </div>
    </section>
  );
};

/* ---------- Sage Panel (full width) ---------- */
const SAGE_PILLARS = [
  {
    title: "Внутреннее спокойствие",
    desc: "Появляется ощущение внутренней тишины. Напряжение постепенно отпускает, становится легче дышать, чувствовать и слышать себя.",
  },
  {
    title: "Ясность и понимание своего пути",
    desc: "То, что раньше казалось запутанным, начинает проясняться. Становится легче понимать, чего ты действительно хочешь и каким может быть следующий шаг.",
  },
  {
    title: "Возвращение контакта с собой",
    desc: "Становится легче слышать свои желания, доверять своим ощущениям и принимать решения без постоянного внутреннего шума.",
  },
  {
    title: "Больше энергии на жизнь",
    desc: "Когда тело перестаёт удерживать постоянное напряжение, освобождается энергия для жизни, отношений, творчества и новых решений.",
  },
  {
    title: "Внутренняя опора",
    desc: "Появляется ощущение, что ответы больше не нужно искать снаружи. Возвращается доверие к себе и своим решениям.",
  },
];

const IntroSage = () => (
  <section
    className="relative overflow-hidden"
    data-testid="intro-sage-section"
    style={{
      backgroundColor: "#fbf4ed",
    }}
  >
    <div className="relative z-10">
      {/* Sage panel - DESKTOP - full width */}
      <div
        className="hidden lg:block relative overflow-hidden"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_webpage-prototype/artifacts/vdtzlboc_image.png')",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="px-16 py-40 xl:px-28 xl:py-48 text-white max-w-[1600px] mx-auto">
          {/* Header */}
          <div className="max-w-3xl mb-20">
            <h3
              className="font-display uppercase tracking-[-0.01em] font-light leading-[1.1]"
              style={{ fontSize: "clamp(30px, 2.7vw, 44px)" }}
            >
              Что ты почувствуешь
              <br />
              после первой сессии
            </h3>
          </div>

          {/* 5 pillars in row */}
          <div className="grid grid-cols-5 gap-x-8 xl:gap-x-10">
            {SAGE_PILLARS.map(({ title, desc }, i) => (
              <div
                key={i}
                data-testid={`sage-pillar-${i}`}
                className={`relative flex flex-col ${
                  i !== 0
                    ? "pl-8 before:content-[''] before:absolute before:left-0 before:top-[6%] before:h-[88%] before:w-px before:bg-white/25"
                    : ""
                }`}
              >
                <h4 className="text-[18px] tracking-[0.02em] leading-[1.35] text-[#e6dbc7] mb-8 min-h-[60px]" style={{ fontFamily: "Manrope, sans-serif", fontWeight: 500 }}>
                  {title}
                </h4>
                <p className="text-white/85 text-[12.5px] leading-[1.85] font-light tracking-[0.02em]">
                  {desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Sage panel - MOBILE */}
      <div
        className="lg:hidden relative text-white overflow-hidden"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_webpage-prototype/artifacts/j6g0d7kf_image.png')",
          backgroundSize: "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="px-8 pt-40 pb-24">
          <h3
            className="font-display uppercase tracking-[-0.02em] font-normal leading-[1.15] text-white"
            style={{ fontSize: "clamp(22px, 6vw, 32px)" }}
          >
            Что ты почувствуешь
            <br />
            после первой сессии
          </h3>

          <div className="mt-14 space-y-10">
            {SAGE_PILLARS.map(({ title, desc }, i) => (
              <div
                key={i}
                data-testid={`sage-pillar-m-${i}`}
                className={i !== 0 ? "pt-10 border-t border-white/20" : ""}
              >
                <h4 className="text-[18px] tracking-[0.02em] text-[#e6dbc7] leading-[1.4] mb-4" style={{ fontFamily: "Manrope, sans-serif", fontWeight: 500 }}>
                  {title}
                </h4>
                <p className="text-white/85" style={{ fontFamily: "Manrope, sans-serif", fontSize: "15px", lineHeight: 1.55, fontWeight: 400 }}>
                  {desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

/* ---------- Resonance list ---------- */
const Resonance = () => {
  const items = [
    "Ты чувствуешь, что выросла из своей прежней жизни.",
    "Внутри всё чаще возникает ощущение: «Так, как раньше, я больше не хочу».",
    "Ты стоишь на пороге перемен, но пока не понимаешь, куда двигаться дальше.",
    "Предстоит важное решение, но ты перестала слышать свой внутренний голос.",
    "Ты устала всё время быть сильной, контролировать и справляться.",
    "Хочется перестать бороться и снова почувствовать внутреннюю опору.",
    "Ты ощущаешь, что внутри уже произошли изменения, но внешняя жизнь ещё не успела за ними.",
    "Старые способы жить, выбирать и строить отношения больше не работают.",
    "Ты чувствуешь, что начинается новый этап жизни, и хочешь пройти его осознанно, а не на автомате.",
    "Ты больше не хочешь жить «правильно», ты хочешь жить по-настоящему, в согласии с собой.",
    "Ты понимаешь, что ответы больше не снаружи. Хочется научиться слышать себя.",
    "Ты хочешь не просто решить очередную проблему, а по-другому проживать свою жизнь.",
    "Ты чувствуешь, что пришло время отпустить то, что уже завершилось, и освободить место для нового.",
    "Ты хочешь вернуть себе ощущение целостности, ясности и спокойной внутренней силы.",
    "Ты понимаешь, что дело уже не во внешних обстоятельствах, а в том, как ты проживаешь этот этап своей жизни.",
  ];

  const visibleItems = items;

  return (
    <section
      id="resonance-section"
      className="px-6 lg:px-14 py-20 lg:py-28 relative overflow-hidden"
      data-testid="resonance-section"
      style={{
        backgroundColor: "#faf2e7",
      }}
    >
      <div className="max-w-4xl mx-auto">
        <h2
          className="text-center font-display uppercase text-warm tracking-[0.08em] font-normal mb-4"
          style={{ fontSize: "clamp(28px, 3.2vw, 44px)" }}
        >
          Кому подойдёт
        </h2>
        <div className="w-12 h-px bg-terracotta/60 mx-auto mb-16" />

        <ul className="space-y-6" data-testid="resonance-list">
          {visibleItems.map((text, i) => (
            <li
              key={i}
              data-testid={`resonance-item-${i}`}
              className="flex gap-5 lg:gap-7 items-start pb-6 border-b border-warm/10 last:border-b-0 group fade-in-up"
            >
              <span
                className="font-display font-normal text-terracotta text-[15px] lg:text-[16px] tracking-[0.02em] leading-none pt-1 flex-shrink-0 w-9 lg:w-10 tabular-nums"
              >
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-warm" style={{ fontFamily: "Manrope, sans-serif", fontSize: "18px", lineHeight: 1.55, fontWeight: 400 }}>
                {text}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

/* ---------- Process steps ---------- */
const Process = () => {
  const steps = [
    {
      num: "01",
      title: "Знакомство",
      desc: "Созваниваемся на 15 минут. Ты рассказываешь, что у тебя сейчас, чего хочешь от практики. Я объясняю, как всё пройдёт и отвечаю на вопросы.",
    },
    {
      num: "02",
      title: "Сессия дыхания",
      desc: "30–40 минут осознанного связанного дыхания. Ты лежишь, я веду процесс голосом. Музыка, дыхание, твоё тело. Всё, что нужно для работы.",
    },
    {
      num: "03",
      title: "Интеграция",
      desc: "После практики проговариваем, что произошло, какие ощущения и выводы. Перевожу опыт в понятные шаги для жизни. Что делать дальше.",
    },
  ];

  return (
    <section
      id="process"
      className="relative overflow-hidden"
      data-testid="process-section"
    >
      {/* DESKTOP */}
      <div
        className="hidden lg:block relative"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_webpage-prototype/artifacts/hklurmee_image.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="px-6 lg:px-14 py-28 max-w-[1400px] mx-auto">
          <div className="text-center mb-20">
            <p className="uppercase text-[11px] tracking-[0.42em] text-warm-light mb-5 font-light">
              Как проходит работа
            </p>
            <h2
              className="font-display text-warm uppercase tracking-[0.02em] font-normal"
              style={{ fontSize: "clamp(36px, 4.4vw, 64px)", lineHeight: 1.05 }}
              data-testid="process-title"
            >
              Три простых
              <br />
              <span className="font-italic-serif text-terracotta">шага</span>
            </h2>
          </div>

          <div className="grid grid-cols-3 gap-10">
            {steps.map((s, i) => (
              <div
                key={i}
                data-testid={`process-step-${i}`}
                className={`px-6 ${i !== 0 ? "border-l border-warm/15" : ""}`}
              >
                <span className="font-display text-terracotta text-3xl leading-none">
                  {s.num}
                </span>
                <h3
                  className="font-display uppercase text-warm tracking-[0.02em] font-normal leading-[1.15] mt-5"
                  style={{ fontSize: "clamp(20px, 1.9vw, 28px)" }}
                >
                  {s.title}
                </h3>
                <p className="text-warm-light text-[13.5px] leading-[1.95] font-light mt-5 max-w-[280px]">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MOBILE */}
      <div
        className="lg:hidden relative"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_webpage-prototype/artifacts/fhastuif_image.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="px-6 py-20">
          <div className="text-center mb-14">
            <p className="uppercase text-[10px] tracking-[0.38em] text-warm-light mb-4 font-light">
              Как проходит работа
            </p>
            <h2
              className="font-display text-warm uppercase tracking-[0.02em] font-normal leading-[1.05]"
              style={{ fontSize: "clamp(30px, 9vw, 44px)" }}
            >
              Три простых
              <br />
              <span className="font-italic-serif text-terracotta">шага</span>
            </h2>
          </div>

          <div className="space-y-10">
            {steps.map((s, i) => (
              <div
                key={i}
                data-testid={`process-step-mobile-${i}`}
                className={i !== 0 ? "pt-10 border-t border-warm/15" : ""}
              >
                <span className="font-display text-terracotta text-2xl leading-none">
                  {s.num}
                </span>
                <h3 className="font-display uppercase text-warm tracking-[0.02em] font-normal leading-[1.1] mt-3 text-[22px]">
                  {s.title}
                </h3>
                <p className="text-warm-light text-[13px] leading-[1.9] font-light mt-4">
                  {s.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ---------- About Master (Elena) ---------- */
const AboutMaster = () => {
  const masterImg =
    "https://customer-assets-eiarnc6j.emergentagent.net/job_webpage-prototype/artifacts/89lx3374_IMG_9244.jpeg";

  const paragraphs = [
    <>
      Я&nbsp;сертифицированный проводник дыхательных практик{" "}
      <span className="text-warm">Breathwork Ceremony</span>.
    </>,
    <>
      Уже более пяти лет я&nbsp;исследую влияние дыхания на&nbsp;состояние
      человека и&nbsp;сопровождаю женщин в&nbsp;периоды внутренних изменений.
    </>,
    <>
      За&nbsp;моей работой стоит не&nbsp;только профессиональное обучение,
      но&nbsp;и&nbsp;большой личный путь.
    </>,
    <>
      Многолетняя практика работы с&nbsp;телом и&nbsp;вниманием, работа
      с&nbsp;дыханием, опыт тёмного ретрита, экспедиции в&nbsp;Перу, работа
      с&nbsp;разными подходами к&nbsp;самопознанию и&nbsp;многолетнее
      исследование собственных внутренних процессов.
    </>,
    <>
      Я&nbsp;знаю, каково жить в&nbsp;постоянном внутреннем напряжении.
      Как много сил уходит на&nbsp;то, чтобы всё время справляться,
      держать контроль и&nbsp;искать ответы вовне.
    </>,
    <>
      Именно поэтому сегодня я&nbsp;создаю спокойное и&nbsp;безопасное
      пространство, в&nbsp;котором можно замедлиться, услышать себя
      и&nbsp;прожить важные внутренние изменения без борьбы с&nbsp;собой.
    </>,
    <>
      Я&nbsp;не&nbsp;верю в&nbsp;то, что человека нужно исправлять.
    </>,
    <>
      Я&nbsp;верю, что внутри каждого уже есть всё необходимое. Иногда
      достаточно создать пространство, в&nbsp;котором ты снова
      сможешь услышать себя.
    </>,
  ];

  return (
    <section
      id="about-master"
      className="px-6 lg:px-14 py-20 relative overflow-hidden"
      data-testid="about-master-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* DESKTOP layout - grid: image left, text right, no bg-image jump */}
        <div className="hidden lg:grid grid-cols-[1fr_1.1fr] gap-0 rounded-[28px] overflow-hidden bg-[#f8efe3] items-start">
          <div className="relative overflow-hidden h-[720px]">
            <img
              src={masterImg}
              alt="Elena Efremova"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: "center top" }}
              data-testid="about-master-image"
            />
          </div>

          <div className="p-16 flex flex-col justify-center">
            <div className="max-w-xl">
              <p className="uppercase text-[11px] tracking-[0.32em] text-terracotta mb-5 font-light">
                Обо мне
              </p>
              <h2
                className="font-display text-warm uppercase tracking-[-0.01em] leading-[1.05] font-normal mb-8"
                style={{ fontSize: "clamp(30px, 3.4vw, 46px)" }}
                data-testid="master-title"
              >
                Елена
                <br />
                <span className="text-terracotta">Ефремова</span>
              </h2>

              <div className="space-y-5 text-warm-light" style={{ fontFamily: "Manrope, sans-serif", fontSize: "18px", lineHeight: 1.55, fontWeight: 400 }}>
                {paragraphs.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>

              <div className="mt-10 grid grid-cols-3 gap-4 max-w-md">
                {[
                  { value: "5+", label: "лет\nпрактики" },
                  { value: "100+", label: "проведённых\nсессий" },
                  { value: "∞", label: "личный\nопыт" },
                ].map((s, i) => (
                  <div
                    key={i}
                    className="border-t border-[#c9b59b] pt-4"
                    data-testid={`master-stat-${i}`}
                  >
                    <p className="font-display text-3xl text-terracotta leading-none mb-2">
                      {s.value}
                    </p>
                    <p className="text-warm-light text-[10.5px] uppercase tracking-[0.18em] leading-[1.7] whitespace-pre-line font-light">
                      {s.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* MOBILE layout - fixed photo on top, text below */}
        <div
          className="lg:hidden rounded-[24px] overflow-hidden relative bg-[#f0e5d3]"
        >
          {/* Photo with fixed aspect - doesn't scale on text change */}
          <div className="w-full aspect-[1/1.3] overflow-hidden">
            <img
              src="https://customer-assets-eiarnc6j.emergentagent.net/job_webpage-prototype/artifacts/89lx3374_IMG_9244.jpeg"
              alt="Elena Efremova"
              className="w-full h-full object-cover object-top"
              data-testid="about-master-image-mobile"
            />
          </div>

          {/* Text content */}
          <div className="px-6 pb-10 pt-8 relative z-10">
            <p className="uppercase text-[11px] tracking-[0.32em] text-terracotta mb-4 font-light">
              Обо мне
            </p>
            <h2
              className="font-display text-warm uppercase tracking-[-0.01em] leading-[1.05] font-normal mb-6 whitespace-nowrap"
              style={{ fontSize: "clamp(24px, 6vw, 34px)" }}
            >
              Елена{" "}
              <span className="font-italic-serif text-terracotta">
                Ефремова
              </span>
            </h2>

            <div className="space-y-4 text-warm-light" style={{ fontFamily: "Manrope, sans-serif", fontSize: "16px", lineHeight: 1.55, fontWeight: 400 }}>
              {paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-8 grid grid-cols-3 gap-3">
              {[
                { value: "5+", label: "лет\nпрактики" },
                { value: "100+", label: "сессий\nпроведено" },
                { value: "∞", label: "личный\nопыт" },
              ].map((s, i) => (
                <div
                  key={i}
                  className="border-t border-[#c9b59b] pt-3"
                  data-testid={`master-stat-m-${i}`}
                >
                  <p className="font-display text-2xl text-terracotta leading-none mb-2">
                    {s.value}
                  </p>
                  <p className="text-warm-light text-[9.5px] uppercase tracking-[0.16em] leading-[1.6] whitespace-pre-line font-light">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Method = () => {
  const items = [
    {
      Icon: Wind,
      title: "Дыхание",
      desc: "Связанное дыхание помогает обойти привычный внутренний контроль и мягко соприкоснуться с тем, что долго оставалось непрожитым. Иногда именно там находится причина напряжения, которое невозможно убрать только разговорами.",
    },
    {
      Icon: HandHeart,
      title: "Тело",
      desc: "Тело хранит наш опыт — даже тот, который мы давно перестали осознавать. Через дыхание оно постепенно отпускает накопленное напряжение и возвращается в состояние большей лёгкости и безопасности.",
    },
    {
      Icon: Activity,
      title: "Внимание",
      desc: "Во время практики внимание постепенно перестаёт быть направленным только вовне. Ты начинаешь лучше слышать своё тело, замечать чувства и возвращаться в контакт с собой.",
    },
    {
      Icon: Gem,
      title: "Сопровождение",
      desc: "Я рядом на каждом этапе процесса — до, во время и после практики. Бережно сопровождаю, отвечаю на вопросы, помогаю интегрировать полученный опыт и перенести изменения в повседневную жизнь.",
    },
  ];

  return (
    <section
      id="method"
      className="px-6 lg:px-14 py-16"
      data-testid="method-section"
    >
      {/* DESKTOP - photo as bg full width */}
      <div
        className="hidden lg:block rounded-[24px] overflow-hidden relative min-h-[560px]"
        style={{
          backgroundImage:
            "url('https://customer-assets-eiarnc6j.emergentagent.net/job_webpage-prototype/artifacts/ml5rr4nu_ChatGPT%20Image%2028%20%D0%B8%D1%8E%D0%BB.%202026%20%D0%B3.%2C%2016_08_59.png')",
          backgroundSize: "cover",
          backgroundPosition: "center right",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, rgba(245,216,213,0.85) 0%, rgba(245,216,213,0.6) 35%, rgba(245,216,213,0.15) 60%, rgba(245,216,213,0) 80%)",
          }}
        />

        <div className="relative z-10 p-14 max-w-[1100px]">
          <h2 className="font-display uppercase text-[40px] tracking-tight text-warm mb-6">
            О методе
          </h2>
          <p className="text-warm-light max-w-2xl font-body mb-10" style={{ fontSize: "19px", lineHeight: 1.55, fontWeight: 400 }}>
            Я&nbsp;работаю в&nbsp;методе Conscious Connected Breathing —
            практике осознанного связанного дыхания. Это мягкий телесный
            подход, который помогает снять накопленное напряжение,
            успокоить нервную систему и&nbsp;восстановить контакт с&nbsp;собой.
            Во&nbsp;время практики главным инструментом становится
            не&nbsp;анализ, а&nbsp;дыхание.
          </p>

          <div className="grid grid-cols-4 gap-5">
            {items.map(({ title, desc }, i) => (
              <div
                key={i}
                className="bg-white/80 backdrop-blur-sm rounded-2xl px-7 py-9 border border-white/60 min-h-[300px] flex flex-col"
                data-testid={`method-card-${i}`}
              >
                <h4 className="text-[17px] tracking-[0.02em] text-warm mb-5" style={{ fontFamily: "Manrope, sans-serif", fontWeight: 500 }}>
                  {title}
                </h4>
                <p className="text-warm-light" style={{ fontFamily: "Manrope, sans-serif", fontSize: "15px", lineHeight: 1.6, fontWeight: 400 }}>
                  {desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* MOBILE - photo on top, text below */}
      <div className="lg:hidden rounded-[24px] overflow-hidden bg-pink-soft">
        <div className="h-[180px] overflow-hidden">
          <img
            src="https://customer-assets-eiarnc6j.emergentagent.net/job_webpage-prototype/artifacts/nxsxptpj_ChatGPT%20Image%2028%20%D0%B8%D1%8E%D0%BB.%202026%20%D0%B3.%2C%2016_12_22.png"
            alt="Woman in pink tulle"
            className="w-full h-full object-cover object-[75%_top]"
            data-testid="method-image-mobile"
          />
        </div>
        <div className="p-8">
          <h2 className="font-display uppercase text-3xl text-warm mb-5 tracking-tight">
            О методе
          </h2>
          <p className="text-warm-light font-body text-sm leading-relaxed mb-8">
            Я&nbsp;работаю в&nbsp;методе Conscious Connected Breathing —
            практике осознанного связанного дыхания. Мягкий телесный подход,
            который помогает снять накопленное напряжение, успокоить нервную
            систему и&nbsp;восстановить контакт с&nbsp;собой.
          </p>

          <div className="grid grid-cols-1 gap-3">
            {items.map(({ title, desc }, i) => (
              <div
                key={i}
                className="bg-white/75 backdrop-blur-sm rounded-2xl px-6 py-5 border border-white/60"
                data-testid={`method-card-m-${i}`}
              >
                <h4 className="text-[17px] tracking-[0.02em] text-warm mb-2" style={{ fontFamily: "Manrope, sans-serif", fontWeight: 500 }}>
                  {title}
                </h4>
                <p className="text-warm-light" style={{ fontFamily: "Manrope, sans-serif", fontSize: "14px", lineHeight: 1.55, fontWeight: 400 }}>
                  {desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

/* ---------- Pricing / Formats ---------- */
const Formats = () => {
  const plans = [
    {
      num: "01",
      title: "Знакомство с методом",
      sessions: "2 встречи",
      price: "350€",
      badge: "Если мы ещё не работали вместе",
      tagline:
        "Формат для первого знакомства с методом и со мной. На первой встрече обсуждаем твой запрос и понимаем, подходит ли тебе такой формат работы. На второй проходит полноценная дыхательная практика с разбором опыта.",
      pointsTitle: "Что входит",
      points: [
        "Онлайн-встреча для знакомства и разбора запроса, 60 минут.",
        "Дыхательная сессия, 60–90 минут.",
        "Интеграция и рекомендации после практики.",
      ],
    },
    {
      num: "02",
      title: "Разовая сессия",
      sessions: "1 встреча",
      price: "200€",
      badge: "Когда уже есть опыт первой практики",
      tagline:
        "Для тех, кто уже знаком с методом и хочет вернуться в практику с новым запросом или продолжить внутреннюю работу. Иногда одной встречи достаточно, чтобы прожить важный этап и восстановить ясность.",
      pointsTitle: "Подходит, если ты хочешь",
      points: [
        "прожить конкретную ситуацию",
        "пройти через непростой период",
        "восстановить контакт с собой",
        "поддержать уже начавшиеся изменения",
      ],
    },
    {
      num: "03",
      title: "Программа сопровождения",
      sessions: "4 недели",
      price: "1200€",
      badge: "Для глубоких и устойчивых изменений",
      tagline:
        "Настоящие изменения редко происходят за одну встречу. Когда между сессиями появляется время прожить опыт, а затем снова вернуться в практику, изменения становятся глубже и устойчивее.",
      pointsTitle: "Что входит",
      points: [
        "4 дыхательные сессии, 1 раз в неделю",
        "поддержка между встречами в Telegram",
        "рекомендации и сопровождение в процессе интеграции",
      ],
      featured: true,
    },
  ];

  return (
    <section
      id="formats"
      className="px-6 lg:px-14 py-16 relative overflow-hidden"
      data-testid="formats-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-display uppercase text-[22px] sm:text-3xl lg:text-[52px] leading-[1.05] text-warm mb-4 tracking-tight whitespace-nowrap lg:whitespace-normal">
            Три формата поддержки
          </h2>
          <p className="uppercase text-[13px] tracking-[0.32em] text-warm-light font-light">
            на&nbsp;разных этапах пути
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {plans.map((p, i) => (
            <div
              key={i}
              className={`relative rounded-[20px] px-8 py-10 lg:py-10 flex flex-col backdrop-blur-sm ${
                p.featured
                  ? "bg-white border-2 border-terracotta/40 shadow-[0_30px_60px_-30px_rgba(201,117,89,0.35)]"
                  : "bg-white/85 border border-white/70"
              }`}
              data-testid={`formats-plan-${i}`}
            >
              <h3 className="font-display uppercase text-warm text-[22px] lg:text-[26px] leading-[1.15] tracking-[-0.01em] mb-6">
                {p.title}
              </h3>

              <div className="flex items-baseline gap-3 mb-3">
                <span className="font-display text-[42px] lg:text-[48px] text-terracotta leading-none">
                  {p.price}
                </span>
                <span className="text-warm-light text-[13px] font-light">
                  · {p.sessions}
                </span>
              </div>

              <p className="text-terracotta uppercase text-[10px] tracking-[0.22em] font-medium mb-5 mt-1">
                {p.badge}
              </p>

              <p className="text-warm font-body text-[13.5px] leading-[1.85] mb-6 font-normal">
                {p.tagline}
              </p>

              <div className="pt-5 border-t border-[#eddfd1]">
                <p className="uppercase text-[10.5px] tracking-[0.24em] text-warm font-medium mb-4">
                  {p.pointsTitle}
                </p>
                <ul className="space-y-3">
                  {p.points.map((pt, idx) => (
                    <li
                      key={idx}
                      className="flex gap-3 text-warm-light text-[12.5px] leading-[1.75] font-light"
                    >
                      <span className="text-terracotta mt-1.5 flex-shrink-0">
                        <svg width="6" height="6" viewBox="0 0 6 6">
                          <circle cx="3" cy="3" r="2.5" fill="#c97559" />
                        </svg>
                      </span>
                      <span>{pt}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ---------- Final CTA ---------- */
const FinalCTA = () => (
  <section
    className="px-6 lg:px-14 py-24 relative overflow-hidden"
    data-testid="final-cta-section"
  >
    <div className="relative z-10 text-center max-w-2xl mx-auto">
      <h2
        className="font-display uppercase tracking-[-0.02em] text-warm leading-[1.15] mb-10"
        style={{ fontSize: "clamp(18px, 3vw, 34px)" }}
      >
        Буду рада сопровождать тебя
        <br />
        <span className="text-terracotta">на&nbsp;этом пути</span>
      </h2>
      <a
        href={TG_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary"
        data-testid="final-cta-button"
      >
        Записаться
      </a>
    </div>
  </section>
);

/* ---------- Footer ---------- */
const Footer = () => (
  <footer className="px-6 lg:px-14 py-10 border-t border-[#eddfd1]">
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-warm-light text-xs">
      <div className="flex items-center gap-2">
        <svg width="20" height="22" viewBox="0 0 30 32" fill="none" stroke="#3d2e25" strokeWidth="1.2" aria-hidden="true">
          <polygon points="15,2 28,9 28,23 15,30 2,23 2,9" />
        </svg>
        <span className="font-display tracking-[0.3em] text-warm text-sm">
          BREATH
        </span>
      </div>
      <p className="tracking-wide">
        © {new Date().getFullYear()} Breathwork-практики · Елена Ефремова.
      </p>
      <a
        href={TG_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="uppercase tracking-[0.24em] hover:text-terracotta transition-colors"
        data-testid="footer-tg-link"
      >
        Telegram
      </a>
    </div>
  </footer>
);

/* ---------- Page ---------- */
const Landing = () => {
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <main
      className="bg-cream leaf-bg min-h-screen w-full text-warm overflow-x-hidden"
      data-testid="landing-page"
    >
      <Hero />
      <Resonance />
      <IntroSage />
      <AboutMaster />
      <Method />
      <div
        data-testid="closing-bg"
        style={{
          backgroundColor: "#fbf4ed",
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_webpage-prototype/artifacts/lgxadc6a_image.png')",
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Formats />
        <FinalCTA />
      </div>
    </main>
  );
};

export default Landing;
